import { useSyncExternalStore } from 'react';

/** The shell width from which the note's page lays out for a computer (`@min-[620px]/shell`). */
export const SHELL_WIDE = 620;

/** The shell's own box; the window when there is no shell (a test, a bare page). */
function width(): number {
  const shell = document.querySelector('.app-shell');
  return shell ? shell.getBoundingClientRect().width : window.innerWidth;
}

function subscribe(changed: () => void): () => void {
  window.addEventListener('resize', changed);
  const shell = document.querySelector('.app-shell');
  const observer =
    shell && typeof ResizeObserver === 'function' ? new ResizeObserver(changed) : null;
  if (shell) observer?.observe(shell);
  return () => {
    window.removeEventListener('resize', changed);
    observer?.disconnect();
  };
}

/**
 * True from 620 px of shell width, the same threshold as the `/shell` container queries. For a
 * part that must exist only once, at one width or the other (#952: the decision panel), where CSS
 * hiding would leave two copies, and two sets of ids, in the document.
 */
export function useShellWide(): boolean {
  return useSyncExternalStore(subscribe, () => width() >= SHELL_WIDE);
}
